import { FormControl, type FormControlProps } from '../form-control';
import { FormHelperText, type FormHelperTextProps } from '../form-helper-text';
import { FormLabel, type FormLabelProps } from '../form-label';

export interface FormControlWrapperProps extends FormControlProps {
  formLabelProps?: FormLabelProps;
  formHelperTextProps?: FormHelperTextProps;
  helperText?: string;
  label?: string;
  inputId?: string;
}
export const FormControlWrapper = ({
  children,
  formHelperTextProps,
  helperText,
  inputId,
  formLabelProps,
  label,
  ...props
}: FormControlWrapperProps) => {
  const helperTextId =
    helperText && inputId ? `${inputId}-helper-text` : undefined;
  const formLabelId = label && inputId ? `${inputId}-label` : undefined;

  return (
    <FormControl {...props}>
      {label != null && label !== '' && (
        <FormLabel
          htmlFor={inputId}
          id={formLabelId}
          sx={{ mb: '4px' }}
          {...formLabelProps}
        >
          {label}
        </FormLabel>
      )}
      {children}
      {helperText && (
        <FormHelperText id={helperTextId} {...formHelperTextProps}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
